import React, { FunctionComponent } from "react"
import styles from "./ContactUsPage.module.scss"
import { Typography } from "@material-ui/core"
import { Title } from "../components/Title"
import { useAuth } from "../common/hooks/useAuth"

export const ContactUsPage: FunctionComponent = () => {
    const { branding } = useAuth()
    return (
        <div className={styles.ContactUsPage}>
            <Title text={"Contact"} />
            <Typography variant={"h3"}>Contact Us</Typography>
            {branding && (
                <Typography variant={"subtitle1"}>
                    For application support please contact {branding.contactInfo}
                </Typography>
            )}
            {!branding && (
                <Typography variant={"subtitle1"}>
                    For application support please contact your Lumen support team
                </Typography>
            )}
        </div>
    )
}
